var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuitoTriste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.376 5.364 0 11.988 0C18.624 0 24 5.376 24 12C24 18.624 18.624 24 11.988 24C5.364 24 0 18.624 0 12ZM7.8 7.20007C6.80589 7.20007 6 8.00596 6 9.00007C6 9.99419 6.80589 10.8001 7.8 10.8001C8.79411 10.8001 9.6 9.99419 9.6 9.00007C9.6 8.00596 8.79411 7.20007 7.8 7.20007ZM16.2 7.20007C15.2059 7.20007 14.4 8.00596 14.4 9.00007C14.4 9.99419 15.2059 10.8001 16.2 10.8001C17.1941 10.8001 18 9.99419 18 9.00007C18 8.00596 17.1941 7.20007 16.2 7.20007ZM12 21.6C6.69602 21.6 2.40002 17.304 2.40002 12C2.40002 6.69596 6.69602 2.39996 12 2.39996C17.304 2.39996 21.6 6.69596 21.6 12C21.6 17.304 17.304 21.6 12 21.6ZM6.41999 17.496C7.64399 15.564 9.71999 14.4 12 14.4C14.28 14.4 16.356 15.552 17.592 17.496C17.856 17.916 17.724 18.468 17.304 18.732C17.148 18.816 16.992 18.864 16.824 18.864C16.524 18.864 16.224 18.72 16.056 18.444C15.168 17.028 13.656 16.188 12 16.188C10.344 16.188 8.83199 17.028 7.94399 18.444C7.67999 18.864 7.12799 18.996 6.70799 18.732C6.28799 18.468 6.15599 17.916 6.41999 17.496Z",
    fill: "#DA1414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuitoTriste);
export default __webpack_public_path__ + "static/media/MuitoTriste.a3ada391b1bc02ff78742b24c707ea74.svg";
export { ForwardRef as ReactComponent };